module.exports = __webpack_public_path__ + "static/media/5.40a1e5b8.png";